import React from 'react'
import { useTranslation } from 'react-i18next'

import { Loader } from 'components'
import { TableFullContent, TBody } from 'components/Table'
import { IconFolder } from 'components/Icons'

interface Props {
  colSpan: number
  isLoading?: boolean
  isNotFound?: boolean
  customNotFoundText?: string
}

const ActionEventTable: React.FC<Props> = ({
  colSpan,
  isLoading,
  isNotFound,
  customNotFoundText,
}: Props) => {
  const { t } = useTranslation('common')

  const renderChildren = (): string | JSX.Element => {
    let result: JSX.Element = <Loader size='lg' />
    if (isLoading) {
      result = <Loader size='lg' />
    }

    if (isNotFound) {
      result = (
        <div className='tbody__not-found-component'>
          <IconFolder className='icon--not-found-icon' />
          <span className='tbody__not-found-text'>
            {customNotFoundText || t('dataNotFound.label')}
          </span>
        </div>
      )
    }

    return result
  }

  return (
    <TBody>
      <TableFullContent colSpan={colSpan}>{renderChildren()}</TableFullContent>
    </TBody>
  )
}

export default ActionEventTable
